import * as React from 'react'
import { styled, theme } from '../../../common/ui'

export function RodoInfo({ url, title }: { url: string; title: string }) {
  return (
    <Container>
      <Title>Klauzula informacyjna art. 13 RODO </Title>
      <P>
        <A href={url} target="_blank">
          {title}
        </A>
      </P>
    </Container>
  )
}

const Container = styled.div`
  padding: 25px;
  margin-bottom: 25px;
  background-color: ${theme.colors.grayDarker};
`
const Title = styled.h4`
  padding: 0;
  margin: 0 0 20px 0;
  color: #2c2c2c;
`
const P = styled.p`
  padding: 0;
  margin: 0;
  color: #2c2c2c;
`
const A = styled.a`
  padding: 0;
  margin: 0;
  text-decoration: underline;
  color: ${theme.colors.primaryDark1};
  &:hover {
    color: ${theme.colors.black};
  }
  &:active {
    color: ${theme.colors.black};
  }
  &:focus {
    color: ${theme.colors.black};
  }
`
